<template>
<div class="chapter">
<div class="inner_page">
<p class="p4">Mi sincera gratitud a:</p>
<p class="p5"> </p>
<p class="p5">Amy y Carol,</p>
<p class="p5">por su incansable guía.</p>
<p class="p5"> </p>
<p class="p5">Troy, por ayudarme a trabajar</p>
<p class="p5">esas 11.000 palabras finales.</p>
<p class="p5"> </p>
<p class="p5"> </p>
<p class="p5">Mi marido Sean,</p>
<p class="p5">por apoyarme de todas las maneras</p>
<p class="p5">posibles con su mayor empeño,</p>
<p class="p5">incluso cuando le prestaba</p>
<p class="p5">más atención a Angelo que a él.</p>
<p class="p6"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?179f7246